var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { APPLICANTS, APPLICATION } from '../../../config/routes';
import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams, useRouteMatch } from 'react-router-dom';
import { ApplicationFormStatus, formTypeName, services } from '../../../shared';
import { Icon } from '../../shared';
import { defaultErrorResponse, hasError } from '../../../shared/types/service-handling';
import './workflow.scss';
import { useWorkflowStore } from '../../store/workflowStore';
export var workflowInitialState = {
    data: undefined,
    loading: false,
    error: false,
};
export var Workflow = function (_a) {
    var caseId = _a.caseId, loanPurposeId = _a.loanPurposeId, setWorkflowSteps = _a.setWorkflowSteps, setActiveWorkflowStep = _a.setActiveWorkflowStep, location = _a.location;
    var addWorkflow = useWorkflowStore(function (state) { return state.addWorkflowStore; });
    var removeWorkflow = useWorkflowStore(function (state) { return state.removeWorkflowStore; });
    var formId = useParams().formId;
    var path = useRouteMatch().path;
    var _b = useState([]), steps = _b[0], setSteps = _b[1];
    var _c = useState(workflowInitialState), shWorkflowSteps = _c[0], setShWorkflowSteps = _c[1];
    var history = useHistory();
    var workflowStr = useWorkflowStore(function (state) { return ({ workflowStr: state.workflowStr }); }).workflowStr;
    useEffect(function () {
        var _a, _b, _c, _d;
        if (loanPurposeId) {
            setShWorkflowSteps(__assign(__assign({}, shWorkflowSteps), { loading: true }));
            if ((localStorage.getItem('workflow') == null) ||
                Object.entries(workflowStr).length == 0 ||
                formId != ((_a = workflowStr[0]) === null || _a === void 0 ? void 0 : _a.preFormId) ||
                caseId != ((_b = workflowStr[0]) === null || _b === void 0 ? void 0 : _b.preCaseId)) {
                (caseId
                    ? services.getDynamicWorkflow(Number(caseId), loanPurposeId)
                    : services.getWorkflowSteps(loanPurposeId)).then(function (result) {
                    var _a, _b;
                    setShWorkflowSteps(result);
                    var workflowSteps = __spreadArray([defaultApplicationWorkflow], ((_b = (_a = result === null || result === void 0 ? void 0 : result.data) === null || _a === void 0 ? void 0 : _a.workflowSteps) !== null && _b !== void 0 ? _b : []), true);
                    removeWorkflow();
                    var newResult = __assign(__assign({}, result), { preCaseId: caseId, preFormId: formId });
                    addWorkflow(newResult);
                    selectActiveWorkflowStep(workflowSteps);
                });
            }
            else {
                setShWorkflowSteps(workflowStr[0]);
                var workflowSteps = __spreadArray([defaultApplicationWorkflow], ((_d = (_c = workflowStr[0].data) === null || _c === void 0 ? void 0 : _c.workflowSteps) !== null && _d !== void 0 ? _d : []), true);
                selectActiveWorkflowStep(workflowSteps);
            }
        }
    }, [caseId, loanPurposeId, setActiveWorkflowStep, setWorkflowSteps, history, history.location.pathname, formId]);
    var GetLastCompleted = function (workflowSteps) {
        var completedSteps = workflowSteps.filter(function (step) { return step.isComplete == true && step.id > 1; });
        return completedSteps.length > 0 ? completedSteps[completedSteps.length - 1] : completedSteps[1];
    };
    var defaultApplicationWorkflow = {
        id: 1,
        formType: 'applicants',
        stepOrder: 0,
        isActive: false,
        formId: 0,
        applicationFormStatus: caseId > 0 ? ApplicationFormStatus.Completed : ApplicationFormStatus.NoStatus,
        isComplete: true,
        disable: false,
    };
    var selectActiveWorkflowStep = function (workflowSteps) {
        var _a, _b;
        var currentFormId = Number(formId !== null && formId !== void 0 ? formId : 0);
        var activeStep = path.match(APPLICANTS.path)
            ? workflowSteps[0]
            : currentFormId === 0
                ? (_a = workflowSteps.find(function (step) { return !step.isComplete && step.id > 1; })) !== null && _a !== void 0 ? _a : GetLastCompleted(workflowSteps)
                : (_b = workflowSteps.find(function (step) { return step.formId === currentFormId; })) !== null && _b !== void 0 ? _b : workflowSteps[1];
        if (activeStep)
            activeStep.isActive = true;
        var adminformId = sessionStorage.getItem('formId');
        if (adminformId !== 'null' && adminformId !== null && adminformId !== undefined && adminformId !== "") {
            workflowSteps.map(function (workflowStep, i) {
                workflowStep.disable = Number(adminformId) !== workflowStep.formId;
            });
        }
        setSteps(workflowSteps);
        if (setWorkflowSteps)
            setWorkflowSteps(workflowSteps);
        if (setActiveWorkflowStep)
            setActiveWorkflowStep(activeStep);
    };
    if (hasError([shWorkflowSteps])) {
        return defaultErrorResponse();
    }
    return (React.createElement("div", { className: "c-app-workflow-wrap" },
        React.createElement("ol", { className: "c-app-workflow" }, steps.map(function (step, i) {
            var itemClasses = 'c-app-workflow__item';
            var iconName = step.formType.toLowerCase();
            if (step.disable) {
                itemClasses += ' isDisabled';
            }
            if (step.isActive) {
                itemClasses += ' isActive';
            }
            if (step.applicationFormStatus == ApplicationFormStatus.Completed ||
                step.applicationFormStatus == ApplicationFormStatus.Completion ||
                step.applicationFormStatus == ApplicationFormStatus.Pass) {
                itemClasses += ' isComplete';
            }
            if (step.applicationFormStatus == ApplicationFormStatus.Referred ||
                step.applicationFormStatus == ApplicationFormStatus.Pending ||
                step.applicationFormStatus == ApplicationFormStatus.ReferredWaitingForMoreInfo ||
                step.applicationFormStatus == ApplicationFormStatus.ReferredWithMoreInfoSubmited) {
                itemClasses += ' isReferred';
            }
            if (step.applicationFormStatus == ApplicationFormStatus.Declined ||
                step.applicationFormStatus == ApplicationFormStatus.AutoDeclined ||
                step.applicationFormStatus == ApplicationFormStatus.AutoDeclinedWaitingForMoreInfo) {
                itemClasses += ' isFailed';
            }
            var formName = "".concat(step.formType.charAt(0).toUpperCase()).concat(step.formType.substring(1, step.formType.length));
            var AddLink = function (children) {
                if ((!caseId || caseId < 0 || step.id <= 1 || !location || !step.isComplete) &&
                    step.applicationFormStatus != ApplicationFormStatus.Pending)
                    return children;
                return (React.createElement(Link, { className: step.disable ? "is-disableLink" : "is-link", key: "w-link-".concat(step.id), to: {
                        pathname: step.formType == formTypeName.illustration
                            ? "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(step.formId, "/Illustrations")
                            : "".concat(APPLICATION.paths[0], "/").concat(caseId, "/").concat(loanPurposeId, "/").concat(step.formId).concat(step.isComplete ? '/Submit' : ''),
                        state: location === null || location === void 0 ? void 0 : location.state,
                    } }, children));
            };
            return AddLink(React.createElement("li", { key: "w-".concat(step.id), className: itemClasses },
                React.createElement(Icon, { name: iconName }),
                React.createElement("span", { className: "c-app-workflow__name" }, "0".concat(i + 1, " | ").concat(formName))));
        }))));
};
